import React, { useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import AgentsTab from './AgentsTab';
import QueuesTab from './QueuesTab';
import RulesTab from './RulesTab';
import SettingsTab from './SettingsTab';
import LogsTab from './LogsTab';
import './RoundRobin.css';

export default function RoundRobinApp() {
  const [activeTab, setActiveTab] = useState('agents');

  return (
    <div>
      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-4">
        <Tab eventKey="agents" title="Agents">
          <AnimatePresence mode="wait">
            <motion.div key="agents" initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} exit={{opacity:0}} transition={{duration:0.2}}>
              <AgentsTab />
            </motion.div>
          </AnimatePresence>
        </Tab>
        <Tab eventKey="queues" title="Queues">
          <AnimatePresence mode="wait">
            <motion.div key="queues" initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} exit={{opacity:0}} transition={{duration:0.2}}>
              <QueuesTab />
            </motion.div>
          </AnimatePresence>
        </Tab>
        <Tab eventKey="rules" title="Rules">
          <AnimatePresence mode="wait">
            <motion.div key="rules" initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} exit={{opacity:0}} transition={{duration:0.2}}>
              <RulesTab active={activeTab === 'rules'} />
            </motion.div>
          </AnimatePresence>
        </Tab>
        <Tab eventKey="settings" title="Settings">
          <AnimatePresence mode="wait">
            <motion.div key="settings" initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} exit={{opacity:0}} transition={{duration:0.2}}>
              <SettingsTab />
            </motion.div>
          </AnimatePresence>
        </Tab>
        <Tab eventKey="logs" title="Logs">
          <AnimatePresence mode="wait">
            <motion.div key="logs" initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} exit={{opacity:0}} transition={{duration:0.2}}>
              <LogsTab />
            </motion.div>
          </AnimatePresence>
        </Tab>
      </Tabs>
    </div>
  );
}
